import {
  ChangeUserAmountFormType,
  CreateExcelRewardUploadRowType,
  CreateExcelUploadRowType,
  CreatePointAchieveType,
  CreatePointAcumulatedType,
  CreatePointSeasonType,
  CreatePointSettingType,
  IdsType,
} from '@/types';
import { axiosDelete, axiosPost } from '../AxiosApi';
import { sendRequest } from '../AxiosRequest';

export const pointSettings = async (createPointSettingType: CreatePointSettingType) => {
  const payload = {
    path: '/point-settings',
    body: { ...createPointSettingType },
  };
  return sendRequest(payload, 'pointSettings', axiosPost);
};

export const pointAcumulated = async (createPointAcumulatedType: CreatePointAcumulatedType) => {
  const payload = {
    path: '/point-settings/accumulated',
    body: { ...createPointAcumulatedType },
  };
  return sendRequest(payload, 'pointSettings', axiosPost);
};

export const pointExcelUpload = async (createExcelUploadRowType: CreateExcelUploadRowType[]) => {
  const payload = {
    path: '/point-admins',
    body: createExcelUploadRowType,
  };
  return sendRequest(payload, 'pointExcelUpload', axiosPost);
};

export const CreatepointUserLedger = async (changeUserAmountFormType: ChangeUserAmountFormType) => {
  const payload = {
    path: '/point-admins',
    body: { ...changeUserAmountFormType },
  };
  return sendRequest(payload, 'CreatepointUserLedger', axiosPost);
};

export const CreateUserLedger = async (changeUserAmountFormType: ChangeUserAmountFormType) => {
  const payload = {
    path: '/point-admins/user-ledger-create',
    body: { ...changeUserAmountFormType },
  };
  return sendRequest(payload, 'CreateUserLedger', axiosPost);
};

export const createSeason = async (createPointSeasonType: CreatePointSeasonType) => {
  const payload = {
    path: '/point-settings/season',
    body: { ...createPointSeasonType },
  };
  return sendRequest(payload, 'createSeason', axiosPost);
};
export const createPointAchieve = async (createPointAchieveType: CreatePointAchieveType) => {
  const payload = {
    path: '/point-settings/achieve',
    body: { ...createPointAchieveType },
  };
  return sendRequest(payload, 'CreatePointAchieve', axiosPost);
};

export const deletePointUsers = async (idsType: IdsType) => {
  const payload = {
    path: '/point-admins/delete-users',
    body: { ...idsType },
  };
  return sendRequest(payload, 'deletePointUsers', axiosDelete);
};

export const pointExcelRewardUpload = async (createExcelRewardUploadRowType: CreateExcelRewardUploadRowType[]) => {
  const payload = {
    path: '/point-admins/season-reward-upload',
    body: createExcelRewardUploadRowType,
  };
  return sendRequest(payload, 'pointExcelRewardUpload', axiosPost);
};
